/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ButtonEl} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';
import {ModalEl} from 'common/components/modal';

import fyt from './fyt.png';
import type {FYTModal} from './index';

export function template(this: FYTModal) {
  return (
    <ModalEl
      sel='.fyt-modal'
      attrs={{elref: `fyt-modal`, open: true, closeable: true}}
      on={{change: this.handleFYTModalStateChanged}}
    >
      <div sel='.fyt-modal-wrapper'>
        <div sel='.fyt-modal-body.wider'>
          <>
            <div sel='.fyt-modal-pre-title'>Find Your Organization</div>
            <div sel='.fyt-modal-title'>A faster way to get all your teammates into Mixpanel</div>
            <div>
              Find Your Organization lets you make your organization searchable, joinable or undiscoverable to new users
              with your shared email domain.
            </div>
            <br />
            <div>
              By default, team members can now join your org by request. You can modify these settings at any time.
            </div>
            <br />
          </>
          <ButtonEl attrs={{theme: ButtonTheme.Primary}} on={{click: this.handleEditDiscoverabilityButtonClicked}}>
            Edit Discoverability
          </ButtonEl>
        </div>
        <img sel='.fyt-image' attrs={{src: fyt}} />
      </div>
    </ModalEl>
  );
}
